import CityPageTemplate from "../city-template/CityPageTemplate";
import { broomfieldConfig } from "./data";

export default function BroomfieldPage() {
  return <CityPageTemplate config={broomfieldConfig} />;
}